import React, { useEffect, useState, useMemo, useRef } from "react";
import ACMarksCentrePanel from "../../components/AssessmentCriteria/ACMarksCentrePanel";
import ACMarksSidePanel from "../../components/AssessmentCriteria/ACMarksSidePanel";
import "./ACMarksDashboardPage.css";
import { useLocation } from "react-router-dom";
import { useCenter } from "../../context/CenterContext";
import { useSubject } from "../../context/SubjectContext";
import toast from "react-hot-toast";
import { Toaster } from "react-hot-toast";
import { useApi } from "../../context/ApiClient";
import { getCenterType, checkunitIsConsortiaUnit } from "../../utils/utils";
import { useConsortiaCenter } from "../../context/ConsortiaCenterContext";
import {
  MARK_STATUS,
  AUTO_SAVE_DELAY_MS,
  AssessmentCriteria,
  AssessmentCriteriaInputValues,
} from "../../constants/Constants";
import { useAuth } from "react-oidc-context";
import UpdateTotalMarksConfirmModal from "../../components/UpdateMarkSubmission/UpdateTotalMarksConfirmModal";
import { useUnits } from "../../context/UnitsContext";

const ACMarksDashboardPage = () => {
  const [assessmentCandidateData, setAssessmentCandidateData] = useState([]);
  const [totalMarks, setTotalMarks] = useState(0);
  const [selectedCandidate, setSelectedCandidate] = useState("");
  const [selectedCandidateAssessmentList, setSelectedCandidateAssessmentList] =
    useState({});
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

  const [missingOrInvalidCandidates, setMissingOrInvalidCandidates] = useState(
    [],
  );
  const location = useLocation();
  const { mode = "edit" } = location.state || {};
  const { consortiaCentres = [] } = useConsortiaCenter();

  const { unit, sessionId } = location.state || {};
  const { consortiaUnits = [] } = useUnits();

  const { centerNumber } = useCenter();
  const {subjectData} = useSubject();
  const {selectedSubject, selectedSubjectId} = subjectData || {};
  const currentCentreType =
        getCenterType(consortiaCentres, Number(centerNumber), selectedSubject, selectedSubjectId) || "";

 

  const unitcode = unit.split(" ")[0];
  
         const consortiaUnitcode =
      String(unit ?? "")
        .toUpperCase()
        .match(/^[A-Z0-9]+/)?.[0] || "";
    const isConsortiaUnit = checkunitIsConsortiaUnit(
      consortiaCentres,
      centerNumber,
      sessionId,
      consortiaUnitcode,
    );
  const baseUrl = process.env.REACT_APP_AMS_BASE_URL;
  const api = useApi((["Rest","Lead"].includes(currentCentreType) && isConsortiaUnit) ? `${baseUrl}consortia/` : baseUrl);

  // single array of objects for all candidate payloads
  const [candidatePayloadData, setCandidatePayloadData] = useState([]);
  const [showModal, setShowModal] = useState(false);

  const [candidateAchievedCounts, setCandidateAchievedCounts] = useState({});


  const subjectId = subjectData?.selectedSubjectId;

  const [showUpdateMarksModal, setShowUpdateMarksModal] = useState(false);
  const [updateMarksCandidate, setUpdateMarksCandidate] = useState([]);

  // Auto-save snapshots/timers
  const lastSavedRowsRef = useRef(JSON.stringify([]));
  const [lastSavedAt, setLastSavedAt] = useState(null);
  const autoSaveTimeoutRef = useRef(null);
  const auth = useAuth();
  const token = auth.user?.access_token;
  const candidatePayloadRef = useRef(candidatePayloadData);
  const assessmentCandidateDataRef = useRef(assessmentCandidateData);
  const tokenRef = useRef(token);
  
  useEffect(() => {
    tokenRef.current = token;
  }, [token]);
  const finalSaveIfNeededRef = useRef(() => { });

  // Fetch candidate data
  useEffect(() => {
    const fetchAssessmentCandidateData = async () => {
      
      try {
        const unitcode = unit.split(" ")[0];
        let endpoint;

       

        if (isConsortiaUnit === undefined || isConsortiaUnit === null) { return; }
        if (["Lead", "Rest"].includes(currentCentreType)) {

          if (isConsortiaUnit === true) {
            // Lead + Consortia
            if (mode === "view") {
              endpoint = "getConsortiaAssessmentCriteriaDetails";
            } else {
              endpoint = "getConsortiaCandidateAssessmentCriteria";
            }

          } else if (isConsortiaUnit === false) {
            // Lead + NOT Consortia
            if (mode === "view") {
              endpoint = "getAssessmentCriteriaDetails";
            } else {
              endpoint = "getCandidateAssessmentCriteria";
            }
          }

        } else {
          // Non‑Lead OR undefined
          if (mode === "view") {
            endpoint = "getAssessmentCriteriaDetails";
          } else {
            endpoint = "getCandidateAssessmentCriteria";
          }
        }


        const response = await api.get(`${endpoint}`, {
          params: {
            assessmentCode: unitcode,
            centreNumber: centerNumber,
            sessionId: sessionId,
          },
        });

        const data = response.data.data.sort((a, b) =>
          a.candidateName.localeCompare(b.candidateName),
        );

        // Normalize API response
        const normalizedData = data.map((candidate) => ({
          ...candidate,
          candidateNumber:
            candidate.candidateNumber || candidate.centreCandidateNumber,
          centreCandidateNumber:
            candidate.centreCandidateNumber || candidate.candidateNumber,
          criteriaDetails:
            mode === "view"
              ? (candidate.assessmentCriteriaList || [])
                .filter((c) => c && Object.keys(c).length > 0)
                .map((c) => ({
                  assessmentCriteriaName: c.assessmentCriteriaId,
                  assessmentCriteriaDescription: c.assessmentCriteriaDesc,
                  centreAssessmentName: c.assessmentStatus,
                  evidenceLocation: c.evidenceLocation,
                  totalMarks: c.totalMarks,
                  totalCriteriaScore: c.candidateMark || c.totalCriteriaScore,
                }))
              : (candidate.criteriaDetails || [])
                .filter((c) => c && Object.keys(c).length > 0)
                .map((c) => ({
                  assessmentCriteriaName: c.assessmentCriteriaName,
                  assessmentCriteriaDescription:
                    c.assessmentCriteriaDescription,
                  centreAssessmentName: c.centreAssessmentName,
                  evidenceLocation: c.evidenceLocation,
                  totalMarks: c.totalMarks,
                  totalCriteriaScore: c.totalCriteriaScore || c.candidateMark,
                })),
        }));

        setAssessmentCandidateData(normalizedData);

        // Build initial payload for candidate data
        let initialPayload;
        if (mode === "view") {
          // Map API fields for read-only data
          initialPayload = normalizedData.map((candidate) => ({
            centreCandidateNumber: candidate.candidateNumber,
            candidateName: candidate.candidateName,
            centreNumber: candidate.centreNumber || centerNumber,
            assessmentCode: unit.split(" ")[0],
            sessionId,
            criteria: candidate.criteriaDetails.map((c) => ({
              criteriaName: c.assessmentCriteriaName,
              achieved:
                c.centreAssessmentName === AssessmentCriteria.ACHIEVED
                  ? AssessmentCriteriaInputValues.YES
                  : c.centreAssessmentName === AssessmentCriteria.NOT_ACHIEVED
                    ? AssessmentCriteriaInputValues.NO
                    : AssessmentCriteriaInputValues.NOT_ATTEMPTED,
              notes: c.evidenceLocation || "",
            })),
          }));
        } else {
          // Edit mode mapping
          initialPayload = normalizedData.map((candidate) => ({
            centreCandidateNumber: candidate.centreCandidateNumber,
            candidateName: candidate.candidateName,
            centreNumber:candidate.centreNumber || centerNumber,
            assessmentCode: unit.split(" ")[0],
            sessionId,
            criteria: candidate.criteriaDetails.map((c) => ({
              criteriaName: c.assessmentCriteriaName,
              achieved:
                c.centreAssessmentName === AssessmentCriteria.ACHIEVED
                  ? AssessmentCriteriaInputValues.YES
                  : c.centreAssessmentName === AssessmentCriteria.NOT_ACHIEVED
                    ? AssessmentCriteriaInputValues.NO
                    : AssessmentCriteriaInputValues.NOT_ATTEMPTED,
              notes: c.evidenceLocation || "",
            })),
          }));
        }

        setCandidatePayloadData(initialPayload);
        lastSavedRowsRef.current = JSON.stringify(initialPayload);

        // Set the selected candidate based on mode
        if (data.length > 0)
          setSelectedCandidate(
            mode === "view"
              ? data[0].candidateNumber
              : data[0].centreCandidateNumber,
          );
      } catch (err) {
        console.error("Error fetching data:", err);
      }
    };

    fetchAssessmentCandidateData();
  }, [consortiaUnits]);

  const updateCandidateTotalMarksLocally = (
    centreCandidateNumber,
    newTotal,
  ) => {
    setAssessmentCandidateData((prev) =>
      prev.map((candidate) => {
        if (
          candidate.centreCandidateNumber === centreCandidateNumber ||
          candidate.candidateNumber === centreCandidateNumber
        ) {
          return {
            ...candidate,
            criteriaDetails: candidate.criteriaDetails.map((c, index) =>
              index === 0 ? { ...c, totalCriteriaScore: newTotal } : c,
            ),
          };
        }
        return candidate;
      }),
    );
  };

  useEffect(() => {
    if (assessmentCandidateData.length > 0) {
      const totalMarks =
        assessmentCandidateData[0]?.criteriaDetails[0]?.totalMarks || 0;
      setTotalMarks(totalMarks);
    }
  }, [assessmentCandidateData]);
  //Keep refs in sync with latest state so autosave sees all edits
  useEffect(() => {
    candidatePayloadRef.current = candidatePayloadData;
  }, [candidatePayloadData]);

  useEffect(() => {
    assessmentCandidateDataRef.current = assessmentCandidateData;
  }, [assessmentCandidateData]);

  // Set selected candidate details
  useEffect(() => {
    if (!selectedCandidate || assessmentCandidateData.length === 0) return;
    const candidate = assessmentCandidateData.find(
      (val) =>
        val.centreCandidateNumber === selectedCandidate ||
        val.candidateNumber === selectedCandidate,
    );
    setSelectedCandidateAssessmentList(candidate);
  }, [selectedCandidate, assessmentCandidateData]);

  //  handle changes in criteria "yes/no"
  const handleValueChange = (criteriaName, newValue) => {
    setCandidatePayloadData((prev) =>
      prev.map((candidate) => {
        if (candidate.centreCandidateNumber === selectedCandidate) {
          const updatedCriteria = candidate.criteria.map((c) =>
            c.criteriaName === criteriaName ? { ...c, achieved: newValue } : c,
          );
          return { ...candidate, criteria: updatedCriteria };
        }
        return candidate;
      }),
    );
    setHasUnsavedChanges(true);
  };

  //  handle notes change
  const handleNoteChange = (criteriaName, newNote) => {
    setCandidatePayloadData((prev) =>
      prev.map((candidate) => {
        if (candidate.centreCandidateNumber === selectedCandidate) {
          const updatedCriteria = candidate.criteria.map((c) =>
            c.criteriaName === criteriaName ? { ...c, notes: newNote } : c,
          );
          return { ...candidate, criteria: updatedCriteria };
        }
        return candidate;
      }),
    );
    setHasUnsavedChanges(true);
  };

  // Compute achieved counts
  useEffect(() => {
    if (candidatePayloadData.length === 0) return;

    const counts = {};
    candidatePayloadData.forEach((candidate) => {
      const achieved = candidate.criteria.filter(
        (c) => c.achieved === "yes",
      ).length;

      let candidateMarks = 0;
      const candidateObj = assessmentCandidateData.find(
        (x) =>
          x.centreCandidateNumber === candidate.centreCandidateNumber ||
          x.candidateNumber === candidate.centreCandidateNumber,
      );

      if (mode === "view") {
        // For view mode API shape
        candidateMarks =
          candidateObj?.assessmentCriteriaList?.[0]?.candidateMark || 0;
      } else {
        // For entry/edit mode
        candidateMarks =
          candidateObj?.criteriaDetails?.[0]?.totalCriteriaScore || 0;
      }

      counts[candidate.centreCandidateNumber] = {
        achievedCount: achieved,
        candidateMarks: candidateMarks,
      };
    });

    setCandidateAchievedCounts(counts);
  }, [candidatePayloadData, assessmentCandidateData, mode]);

  const getInvalidCandidateNames = (rows, overrides = {}) => {
    const invalid = [];
    rows.forEach((cand) => {
      const filled =
        Array.isArray(cand.criteria) &&
        cand.criteria.length > 0 &&
        cand.criteria.every(
          (item) => item.achieved && String(item.achieved).trim() !== "",
        );

      // Metrics come from state, but can be overridden for the validation
      const baseMetrics =
        candidateAchievedCounts[cand.centreCandidateNumber] || {};
      const metrics = {
        ...(baseMetrics || {}),
        ...(overrides[cand.centreCandidateNumber] || {}),
      };
      const countsOk = metrics.achievedCount === metrics.candidateMarks;

      if (!filled || !countsOk) {
        const found = assessmentCandidateData.find(
          (x) => x.centreCandidateNumber === cand.centreCandidateNumber,
        );
        invalid.push(
          found
            ? found.candidateName.toUpperCase()
            : cand.centreCandidateNumber,
        );
      }
    });
    setHasUnsavedChanges(false);
    return invalid;
  };

  const handleSave = async (rows, saveMode) => {
    try {
      //  Validate candidates before saving
      const invalidCandidates = rows.filter((cand) => {
        const filled =
          Array.isArray(cand.criteria) &&
          cand.criteria.length > 0 &&
          cand.criteria.every(
            (item) => item.achieved && String(item.achieved).trim() !== "",
          );
        const metrics =
          candidateAchievedCounts[cand.centreCandidateNumber] || {};
        const countsOk = metrics.achievedCount === metrics.candidateMarks;

        return !filled || !countsOk;
      });

      // Map invalid candidates to names
      const invalidCandidateNames = invalidCandidates.map((cand) => {
        const found = assessmentCandidateData.find(
          (x) => x.centreCandidateNumber === cand.centreCandidateNumber,
        );
        return found
          ? found.candidateName.toUpperCase()
          : cand.centreCandidateNumber;
      });

      // Update state (this will show the message)
      setMissingOrInvalidCandidates(invalidCandidateNames);

      //  Proceed with save
      const formattedData = [];
      rows.forEach((candidate) => {
        const candidateNumber = candidate.centreCandidateNumber;
        const centreNumber = candidate.centreNumber;
        const assessmentCode = candidate.assessmentCode;
        const sessionId = candidate.sessionId;

        candidate.criteria.forEach((c) => {
          let achievedId;
          if (c.achieved === AssessmentCriteriaInputValues.YES) achievedId = 14;
          else if (c.achieved === AssessmentCriteriaInputValues.NO)
            achievedId = 15;
          else if (c.achieved === AssessmentCriteriaInputValues.NOT_ATTEMPTED)
            achievedId = 13;
          else achievedId = null;

          const candidateMeta = assessmentCandidateData.find(
            (x) => x.centreCandidateNumber === candidate.centreCandidateNumber,
          );
          const criteriaMeta = candidateMeta?.criteriaDetails?.find(
            (cd) => cd.assessmentCriteriaName === c.criteriaName,
          );

          formattedData.push({
            centreNumber,
            sessionId,
            subjectId: subjectId,
            assessmentCode,
            candidateNumber,
            markStatusId: MARK_STATUS.SAVED,
            assessmentCriteriaName: c.criteriaName,
            description:
              criteriaMeta?.assessmentCriteriaDescription || "(No description)",
            assessmentCriteriaAchievedId: achievedId,
            evidenceLocation: c.notes || "",
          });
        });
      });
      const response = (currentCentreType === "Lead" && isConsortiaUnit) ? await api.post(
        `saveOrUpdateACMarksConsortia`,
        formattedData
      ) : await api.post(
        `saveOrUpdateAssessmentCriteriaMarks`,
        formattedData,
      )
      if (response.status === 200) {
        if (saveMode !== "downloadSave")
          toast.success("Your changes have been saved", {
            style: {
              minWidth: "400px",
            },
          });
        localStorage.removeItem(`acMarksData_${sessionId}_${centerNumber}`);
        lastSavedRowsRef.current = JSON.stringify(rows);
        setLastSavedAt(new Date());
        if (autoSaveTimeoutRef.current) {
          clearTimeout(autoSaveTimeoutRef.current);
          autoSaveTimeoutRef.current = null;
        }
      } else {
        alert("Save failed. Please try again.");
      }

      const metrics = candidateAchievedCounts[selectedCandidate] || {};
const selectedCandidateData = rows.find(
  (c) => c.centreCandidateNumber === selectedCandidate
);

const centreNumber = selectedCandidateData?.centreNumber;
      if (metrics.achievedCount !== metrics.candidateMarks) {
        setUpdateMarksCandidate([
          {
            centreCandidateNumber: selectedCandidate,
            achievedCount: metrics.achievedCount,
            candidateMarks: metrics.candidateMarks,
            candidateCentreNumber: centreNumber,
          },
        ]);
        setShowUpdateMarksModal(true);
        return;
      }

      if (!centerNumber) {
        alert("No centre selected");
        return;
      }

      setHasUnsavedChanges(false);
    } catch (error) {
      console.error("Error saving the assessment criteria marks:", error);
    }
  };

  const handleSubmit = () => {
    setShowModal(true);
  };

  //  candidate switching logic
  const handleCandidateSelect = (candidateId) => {
    if (candidateId === selectedCandidate) return;

    if (hasUnsavedChanges) {
      const confirmLeave = window.confirm(
        "You have unsaved changes for this candidate. Do you want to discard them and continue?",
      );

      if (confirmLeave) {
        // Revert current candidate form to API state (not blank)
        setCandidatePayloadData((prev) =>
          prev.map((candidate) => {
            if (candidate.centreCandidateNumber === selectedCandidate) {
              // Find original criteria from API data
              const apiCandidate = assessmentCandidateData.find(
                (c) => c.centreCandidateNumber === selectedCandidate,
              );

              if (!apiCandidate) return candidate; // safety fallback

              const resetCriteria = apiCandidate.criteriaDetails.map((c) => ({
                criteriaName: c.assessmentCriteriaName,
                achieved:
                  c.achieved ||
                    c.centreAssessmentName === AssessmentCriteria.ACHIEVED
                    ? AssessmentCriteriaInputValues.YES
                    : c.centreAssessmentName === AssessmentCriteria.NOT_ACHIEVED
                      ? AssessmentCriteriaInputValues.NO
                      : AssessmentCriteriaInputValues.NOT_ATTEMPTED,
                notes: c.notes || c.evidenceLocation || "",
              }));
              return {
                ...candidate,
                criteria: resetCriteria,
              };
            }
            return candidate;
          }),
        );

        setSelectedCandidate(candidateId);
        setHasUnsavedChanges(false);
      } else {
        return;
      }
    } else {
      //  Normal candidate switch
      setSelectedCandidate(candidateId);
      setHasUnsavedChanges(false);
    }
  };

  const allCandidatesCompleted = useMemo(() => {
    if (!Array.isArray(candidatePayloadData) || !candidatePayloadData.length)
      return false;

    // Every candidate must satisfy:
    // - every criteria item has a non-empty achieved
    // - side panel green icon condition: achievedCount == candidateMarks for that candidateId
    return candidatePayloadData.every((cand) => {
      const filled =
        Array.isArray(cand.criteria) &&
        cand.criteria.length > 0 &&
        cand.criteria.every(
          (item) => item.achieved && String(item.achieved).trim() !== "",
        );

      const metrics = candidateAchievedCounts[cand.centreCandidateNumber] || {};
      const countsOk = metrics.achievedCount === metrics.candidateMarks;

      return filled && countsOk;
    });
  }, [candidatePayloadData, candidateAchievedCounts]);

  //  current candidate info
  const currentCandidate =
    candidatePayloadData.find(
      (c) => c.centreCandidateNumber === selectedCandidate,
    ) || {};
  const achievedCount =
    currentCandidate.criteria?.filter((c) => c.achieved === "yes").length || 0;
  const totalCriteria = currentCandidate.criteria?.length || 0;

  // Silent auto-save
  const handleAutoSave = async () => {
    // Use refs to ensure latest edits are included at autosave time
    const currentSerialized = JSON.stringify(candidatePayloadRef.current);
    if (currentSerialized === lastSavedRowsRef.current) return;
    try {
      const formattedData = [];
      const payloadSource = candidatePayloadRef.current || [];
      const acMetaSource = assessmentCandidateDataRef.current || [];
      payloadSource.forEach((candidate) => {
        const candidateNumber = candidate.centreCandidateNumber;
        const centreNumber = candidate.centreNumber;
        const assessmentCode = candidate.assessmentCode;
        const sessionIdVal = candidate.sessionId;
        // Find candidate meta from latest AC data for description
        const candidateMeta = acMetaSource.find(
          (x) => x.centreCandidateNumber === candidate.centreCandidateNumber,
        );
        candidate.criteria.forEach((c) => {
          let achievedId;
          if (c.achieved === AssessmentCriteriaInputValues.YES) achievedId = 14;
          else if (c.achieved === AssessmentCriteriaInputValues.NO)
            achievedId = 15;
          else if (c.achieved === AssessmentCriteriaInputValues.NOT_ATTEMPTED)
            achievedId = 13;
          else achievedId = null;
          const criteriaMeta = candidateMeta?.criteriaDetails?.find(
            (cd) => cd.assessmentCriteriaName === c.criteriaName,
          );
          formattedData.push({
            centreNumber,
            sessionId: sessionIdVal,
            subjectId: subjectId,
            assessmentCode,
            candidateNumber,
            markStatusId: MARK_STATUS.SAVED,
            assessmentCriteriaName: c.criteriaName,
            description:
              criteriaMeta?.assessmentCriteriaDescription || "(No description)",
            assessmentCriteriaAchievedId: achievedId,
            evidenceLocation: c.notes || "",
          });
        });
      });
      (currentCentreType === "Lead" && isConsortiaUnit) ? await api.post(
        `saveOrUpdateACMarksConsortia`,
        formattedData
      ) :
        await api.post(`saveOrUpdateAssessmentCriteriaMarks`, formattedData);
      // Update the saved snapshot to the latest payload version
      lastSavedRowsRef.current = currentSerialized;
      setLastSavedAt(new Date());
      setHasUnsavedChanges(false);
      if (autoSaveTimeoutRef.current) {
        clearTimeout(autoSaveTimeoutRef.current);
        autoSaveTimeoutRef.current = null;
      }
    } catch (e) {
      console.error("Auto-save (criteria) failed:", e);
    }
  };
  // Fixed window auto-save
  useEffect(() => {
    const serialized = JSON.stringify(candidatePayloadData);
    const hasUnsaved = serialized !== lastSavedRowsRef.current;
    if (hasUnsaved) {
      if (!autoSaveTimeoutRef.current) {
        autoSaveTimeoutRef.current = setTimeout(() => {
          handleAutoSave();
        }, AUTO_SAVE_DELAY_MS);
      }
    } else {
      if (autoSaveTimeoutRef.current) {
        clearTimeout(autoSaveTimeoutRef.current);
        autoSaveTimeoutRef.current = null;
      }
    }
  }, [candidatePayloadData]);

  useEffect(() => {
    return () => {
      if (autoSaveTimeoutRef.current) {
        clearTimeout(autoSaveTimeoutRef.current);
        autoSaveTimeoutRef.current = null;
      }
    };
  }, []);

  // Build formatted data identical to manual save (includes description)
  const buildFinalFormattedData = () => {
    const formatted = [];
    candidatePayloadData.forEach((candidate) => {
      const candidateNumber = candidate.centreCandidateNumber;
      const centreNumber = candidate.centreNumber;
      const assessmentCode = candidate.assessmentCode;
      const sessionIdVal = candidate.sessionId;
      const candidateMeta = assessmentCandidateData.find(
        (x) => x.centreCandidateNumber === candidate.centreCandidateNumber,
      );
      candidate.criteria.forEach((c) => {
        let achievedId;
        if (c.achieved === AssessmentCriteriaInputValues.YES) achievedId = 14;
        else if (c.achieved === AssessmentCriteriaInputValues.NO)
          achievedId = 15;
        else if (c.achieved === AssessmentCriteriaInputValues.NOT_ATTEMPTED)
          achievedId = 13;
        else achievedId = null;
        const criteriaMeta = candidateMeta?.criteriaDetails?.find(
          (cd) => cd.assessmentCriteriaName === c.criteriaName,
        );
        formatted.push({
          centreNumber,
          sessionId: sessionIdVal,
          subjectId,
          assessmentCode,
          candidateNumber,
          markStatusId: MARK_STATUS.SAVED,
          assessmentCriteriaName: c.criteriaName,
          description:
            criteriaMeta?.assessmentCriteriaDescription || "(No description)",
          assessmentCriteriaAchievedId: achievedId,
          evidenceLocation: c.notes || "",
        });
      });
    });
    return formatted;
  };

  // Final save routine (sendBeacon → fetch keepalive → sync XHR)
  // Sync XHR/sendBeacon/fetch unload save -- with Authorization header
  finalSaveIfNeededRef.current = () => {
    const serialized = JSON.stringify(candidatePayloadData);
    if (serialized === lastSavedRowsRef.current) return; // nothing changed
    const dataArray = buildFinalFormattedData();
    const url = (currentCentreType === "Lead" && isConsortiaUnit) ? `${process.env.REACT_APP_AMS_BASE_URL}consortia/saveOrUpdateACMarksConsortia` : `${process.env.REACT_APP_AMS_BASE_URL}saveOrUpdateAssessmentCriteriaMarks`;
    const body = JSON.stringify(dataArray);
    const currentToken = tokenRef.current;

    // Try sync XHR first (so we can set Authorization header!)
    try {
      const xhr = new XMLHttpRequest();
      xhr.open("POST", url, false);
      xhr.setRequestHeader("Content-Type", "application/json");
      if (currentToken)
        xhr.setRequestHeader("Authorization", "Bearer " + currentToken);
      xhr.send(body);
      lastSavedRowsRef.current = serialized;
      return;
    } catch (e) {
      /* fallback below */
    }

    // Try sendBeacon (if backend allows token in query/body, adjust here if needed)
    try {
      if (navigator.sendBeacon) {
        const blob = new Blob([body], { type: "application/json" });
        navigator.sendBeacon(url, blob);
        lastSavedRowsRef.current = serialized;
        return;
      }
    } catch (e) {
      /* fallback below */
    }

    // Fallback: try fetch keepalive (least reliable for unload, but included for completeness)
    try {
      fetch(url, {
        method: "POST",
        headers: currentToken
          ? {
            "Content-Type": "application/json",
            Authorization: "Bearer " + currentToken,
          }
          : { "Content-Type": "application/json" },
        body,
        keepalive: true,
      });
      lastSavedRowsRef.current = serialized;
    } catch (e) {
      // Fallback failed
    }
  };

  // beforeunload (desktop browsers)
  useEffect(() => {
    const onBeforeUnload = () => {
      finalSaveIfNeededRef.current && finalSaveIfNeededRef.current();
    };
    window.addEventListener("beforeunload", onBeforeUnload);
    return () => window.removeEventListener("beforeunload", onBeforeUnload);
  }, [candidatePayloadData, assessmentCandidateData]);

  // pagehide + visibilitychange (mobile/tab background/close)
  useEffect(() => {
    const onPageHide = () => {
      finalSaveIfNeededRef.current && finalSaveIfNeededRef.current();
    };
    const onVisChange = () => {
      if (document.visibilityState === "hidden") {
        finalSaveIfNeededRef.current && finalSaveIfNeededRef.current();
      }
    };
    window.addEventListener("pagehide", onPageHide);
    document.addEventListener("visibilitychange", onVisChange);
    return () => {
      window.removeEventListener("pagehide", onPageHide);
      document.removeEventListener("visibilitychange", onVisChange);
    };
  }, [candidatePayloadData, assessmentCandidateData]);

  const SuccessIcon = () => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
    >
      {/* White circle with green border */}
      <circle
        cx="12"
        cy="12"
        r="10"
        fill="#FFFFFF"
        stroke="#2B8000"
        strokeWidth="2"
      />
      {/* Green tick */}
      <path
        d="M8 12.5l2.5 2.5L16 9.5"
        fill="none"
        stroke="#2B8000"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
  return (
    <div className="ac-mark-dashboard pnl_page_layout columns is-gapless">
      <div className="pnl_page_content column">
        <Toaster
          position="top-right"
          containerStyle={{ marginTop: "8rem" }}
          toastOptions={{
            style: {
              width: "350px",
              borderRadius: "4px",
              fontFamily:
                "'Open Sans', 'Source Sans 3', Arial, Helvetica, sans-serif",
              boxShadow:
                "rgba(0, 0, 0, 0.14) 0px 8px 12px -4px, rgba(0, 0, 0, 0.24) 0px 4px 6px -2px",
            },
            success: {
              style: {
                backgroundColor: "#f5faf5",
                border: "1px solid #2B8000",
                color: "#2B8000",
              },
              // iconTheme is optional now; icon overrides it
              icon: <SuccessIcon />,
            },
          }}
        />
        <ACMarksSidePanel
          assessmentCandidateData={assessmentCandidateData}
          setSelectedCandidate={handleCandidateSelect}
          selectedCandidate={selectedCandidate}
          candidateDataMap={candidateAchievedCounts}
          candidatePayloadData={candidatePayloadData}
          mode={mode}
        />

        <UpdateTotalMarksConfirmModal
          isOpen={showUpdateMarksModal}
          candidates={updateMarksCandidate}
          onConfirm={() => {
            setShowUpdateMarksModal(false);
            const candidate = updateMarksCandidate[0];
            if (!candidate) return;
            const newTotal = candidate.achievedCount;

            updateCandidateTotalMarksLocally(
              candidate.centreCandidateNumber,
              newTotal,
            );

            setCandidateAchievedCounts((prev) => ({
              ...prev,
              [candidate.centreCandidateNumber]: {
                ...(prev[candidate.centreCandidateNumber] || {}),
                candidateMarks: newTotal,
              },
            }));

            const invalidCandidateNames = getInvalidCandidateNames(
              candidatePayloadData,
              {
                [candidate.centreCandidateNumber]: { candidateMarks: newTotal },
              },
            );

            setMissingOrInvalidCandidates(invalidCandidateNames);
          }}
          onCancel={() => {
            setShowUpdateMarksModal(false);
          }}
        />

        <ACMarksCentrePanel
          assessmentCandidateData={assessmentCandidateData}
          selectedCandidate={selectedCandidate}
          achievedCount={achievedCount}
          totalCriteria={totalCriteria}
          totalMarks={totalMarks}
          candidateDataMap={candidateAchievedCounts}
          criteriaDetails={
            selectedCandidateAssessmentList?.criteriaDetails || []
          }
          values={
            currentCandidate.criteria?.reduce((acc, c) => {
              acc[c.criteriaName] = c.achieved;
              return acc;
            }, {}) || {}
          }
          notes={
            currentCandidate.criteria?.reduce((acc, c) => {
              acc[c.criteriaName] = c.notes;
              return acc;
            }, {}) || {}
          }
          onChangeValue={handleValueChange}
          onChangeNote={handleNoteChange}
          allCandidatesCompleted={allCandidatesCompleted}
          submissionPayload={candidatePayloadData}
          onSave={handleSave}
          onSubmit={handleSubmit}
          selectedCenter={centerNumber}
          setHasUnsavedChanges={setHasUnsavedChanges}
          setShowModal={setShowModal}
          showModal={showModal}
          missingOrInvalidCandidates={missingOrInvalidCandidates}
          mode={mode}
          lastSavedAt={lastSavedAt}
        />
      </div>
    </div>
  );
};

export default ACMarksDashboardPage;
